'use strict';

angular.module('services.modal', ['mgcrea.ngStrap'])

    .factory('modalService', ['$modal', '$rootScope', function ($modal, $rootScope) {
        return {

            /**
             * Display a modal with the provided template as the content.
             * Provide 'okText' in the scope to override default OK button's text.
             *
             * @param {null|string} title - Title of the modal
             * @param {string} templateUrl - url of the html template for the content of the modal
             * @param {Object} scopeContent - all of the own properties will be assigned on the modal scope
             * @param {null|boolean|function} successCb - If function is provided, it will be called when clicking OK with the content of the scope. False to hide OK button. Fucntion can return false to prevent closing the modal.
             * @param {boolean} [allowCancel=true] - false to remove the Cancel button and prevent the user from closing the modal, true by default
             * @param {function} [cancelCb] - If provided, the function is called when closing the modal
             *
             * @return {Object} the object
             */
            displayTemplateModal: function (title, templateUrl, scopeContent, successCb, allowCancel, cancelCb) {
                var modalScope = $rootScope.$new();

                modalScope.title       = title;
                modalScope.templateUrl = templateUrl;
                _.merge(modalScope, scopeContent);
                modalScope.successCb   = successCb;
                modalScope.allowCancel = !angular.isDefined(allowCancel) || allowCancel !== false;
                modalScope.cancelCb    = cancelCb;
                modalScope.modalStyle  = {};

                // Set default min-height
                if (_.isNil(_.get(modalScope, 'ngStyle.min-height'))) {
                    _.set(modalScope, 'ngStyle.min-height', '200px');
                }

                // Widths are set on the parent modal object not the body
                var mWidth = _.get(modalScope, 'ngStyle.width');
                if (!_.isNil(mWidth)) {
                    modalScope.modalStyle.width = mWidth;
                    delete modalScope.ngStyle.width;
                }

                /*
                Disable escape and click on backdrop if cancelCb is provided as there
                are no other way to ensure the cancelCb is called when closing the modal.
                Once we update angular-strap we can use onHide.
                 */
                var backdropValue = modalScope.cancelCb ? 'static' : true;

                var modal = $modal({
                    scope: modalScope,
                    show: true,
                    template: '/app/shared/components/services/modalWithTemplate.tpl.html',
                    placement: 'center',
                    backdrop: modalScope.allowCancel ? backdropValue : 'static',
                    keyboard: !modalScope.cancelCb
                });

                modal.getScope = function () {
                    return modalScope;
                };

                modalScope.onOK = function (form) {
                    var canExit = true;
                    if (_.isFunction(successCb)) {
                        canExit = successCb.call(null, modalScope, form);
                    }

                    if (form.$invalid) {
                        modalScope.showErrors = true;
                    }

                    if (canExit) modal.$promise.then(modal.hide);
                };

                modalScope.onCancel = function () {
                    modal.$promise.then(modal.hide);
                    modal.hide();
                    if (_.isFunction(cancelCb)) {
                        cancelCb.apply(null);
                    }
                };

                modalScope.$on('modal.hide', function () {
                    if (_.isFunction(modalScope.onModalClose)) {
                        modalScope.onModalClose.apply(null);
                    }
                    modalScope.$destroy();
                });

                return modal;
            },

            /**
             * @param title {null|string}
             * If provided, sets the title of the modal, otherwise no header is displayed.
             * It can be valid HTML, but will be set inside a <h4> tag
             *
             * @param contentConfig {key, label, type, required}
             * Object containing the definition of the content of the form, which is an array of field definition as:
             * [{
             *     key: fieldID,
             *     label: "field label",
             *     type: text/texterea, etc., see supported field types
             *     required: true|false
             * }]
             *
             * The type is only one of the following supported values:
             * - text
             *
             * Each field will be displayed in a new line.
             *
             * @param successCb {function}
             * Called when user clicks OK and form is valid, all values are provided as a single parameter as follow:
             * [{<key>: <value>}, {<key>: <value>}]
             *
             * @param allowCancel {boolean}
             * By default, there is a cancel button to close the modal without action.
             * Set this to false to prevent it.
             *
             * @param cancelCb {function}
             * Called when user cancels when allowed, no parameter is provided
             */
            displayFormModal: function (title, contentConfig, successCb, allowCancel, cancelCb) {
                var modalScope = $rootScope.$new();

                if (title === '') {
                    title = null;
                }
                modalScope.title         = title;
                modalScope.contentConfig = contentConfig;
                modalScope.values        = {};
                modalScope.successCb     = successCb;
                modalScope.allowCancel   = !angular.isDefined(allowCancel) || allowCancel !== false;
                modalScope.cancelCb      = cancelCb;
                modalScope.showErrors    = false;

                var modal = $modal({
                    scope: modalScope,
                    show: true,
                    template: '/app/shared/components/services/modalForm.tpl.html',
                    placement: 'center',
                    backdrop: modalScope.allowCancel ? true : 'static'
                });

                modalScope.onOK = function (form) {
                    // If valid form:
                    if (form.$valid) {
                        modal.$promise.then(modal.hide);
                        if (_.isFunction(successCb)) {
                            successCb.call(null, modalScope.values);
                        }
                    } else {
                        modalScope.showErrors = true;
                    }
                };

                modalScope.onCancel = function () {
                    modal.$promise.then(modal.hide);
                    if (_.isFunction(cancelCb)) {
                        cancelCb.apply(null);
                    }
                };
            },

            /**
             * Display Follow Ups in a modal
             * @param title {string} Modal title, tries to use the Plan Deliverable or Action Plan Criteria's title if title is null
             * @param [assessment] {Object} Assessment which contains the follow-ups
             * @param [followUps] {Array} List of follow-ups
             * @param [assessmentContainers] {Array} List of all assessments to get the current assessment from
             * @param [getDownloadAttachmentUrl] {function} Function used to get the attachment's URL. Function is called with the attachment's external ID
             * @returns {IScope|*|Object}
             */
            displayFollowUps: function (title, assessment, followUps, assessmentContainers, getDownloadAttachmentUrl) {
                var modalScope = $rootScope.$new();

                modalScope.assessment               = assessment;
                modalScope.currentFollowUps         = followUps;
                modalScope.newFollowUp              = {};
                modalScope.getDownloadAttachmentUrl = getDownloadAttachmentUrl;
                modalScope.pastAssessmentContainers = _.chain(assessmentContainers)
                    .reject({'Assessment.AssessmentID': _.get(assessment, 'AssessmentID')})
                    .reject(function (o) {
                        return !o.FollowUps || !o.FollowUps.length;
                    })
                    .value();

                // if there is no assessment, look into all assessments to get the current assessment
                if (!assessment && assessmentContainers && assessmentContainers.length) {
                    assessmentContainers.some(function (assessmentContainer) {
                        if (assessmentContainer.Assessment.GovernanceProcess.IsActive) {
                            modalScope.assessment = assessmentContainer.Assessment;
                            return true;
                        }
                    });
                }

                modalScope.title = title ? title : modalScope.assessment ? getTitle(modalScope.assessment) : null;

                var showModal = $modal({
                    scope: modalScope,
                    template: '/app/shared/grc/businessPlanning/assessment/assessmentFollowUpsModal.tpl.html',
                    placement: 'center'
                });

                modalScope.hideModal = function () {
                    showModal.$promise.then(showModal.hide);
                };

                modalScope.okModal = function () {
                    modalScope.hideModal();
                };

                function getTitle(assessment) {
                    var obj = assessment.PlanDeliverable || assessment.ActionPlanCriteria;

                    return obj ? obj.TitleEN : null;
                }

                return modalScope;
            },

            // Supported field types
            types: {
                TEXT: 'text'
            }
        };
    }]);
